import React from 'react';
import { motion } from 'framer-motion';
import PageHero from '../components/PageHero';
import { BELIEFS } from '../data/beliefs';
import usePageMeta from '../hooks/usePageMeta';
import styles from './WhatWeBelieve.module.css';

export default function WhatWeBelieve() {
  usePageMeta(
    'What We Believe — Revive Worship',
    'The historic Christian faith, anchored in thirteen statements that shape everything we do as a worship ministry.'
  );

  return (
    <>
      <PageHero
        eyebrow="What We Believe"
        title={['What we hold to.']}
        lede="The historic Christian faith, anchored in thirteen statements that shape everything we do as a worship ministry."
        image="/images/believe.jpg"
      />

      {/* Index */}
      <section className={styles.indexBlock}>
        <div className={styles.shell}>
          <p className={styles.indexLabel}>Index</p>
          <ol className={styles.indexList}>
            {BELIEFS.map((b, i) => (
              <li key={b.id}>
                <a className={styles.indexLink} href={`#${b.id}`}>
                  <span className={styles.indexNum}>{String(i + 1).padStart(2, '0')}</span>
                  <span className={styles.indexTitle}>{b.title}</span>
                  <span className={styles.indexArrow} aria-hidden="true">→</span>
                </a>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* Doctrinal content */}
      <section className={styles.body}>
        <div className={styles.shell}>
          {BELIEFS.map((b, i) => (
            <motion.article
              id={b.id}
              key={b.id}
              className={styles.article}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
              <div className={styles.articleNum}>
                <span>{String(i + 1).padStart(2, '0')}</span>
                <span className={styles.articleNumRule} />
              </div>
              <div className={styles.articleContent}>
                <h2 className={styles.articleTitle}>{b.title}</h2>
                <p className={styles.articleBody}>{b.body}</p>
                <span className={styles.articleRefs}>{b.refs}</span>
              </div>
            </motion.article>
          ))}
        </div>
      </section>
    </>
  );
}
